module.exports = __webpack_public_path__ + "static/img/1.5a478ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/sp/1.png
// module id = 4lzF
// module chunks = 0